import React from 'react';
import { GHLink } from '../types/types';

interface ResourceListProps {
	resources: Array<GHLink>;
}

const ResourceList: React.FC<ResourceListProps> = ( { resources } ) => {
	return (
		<div className="c-guided-help__resources">
			{resources.map( ( block ) => {
				const { id, label, url } = block;

				return (
					<a key={id} className="a-block-cta a-block-cta--reverse" href={url} data-link-click>
						<span>{label}</span>
						<span
							className="a-block-cta__icon icon-arrow-right"
							aria-hidden="true"
						></span>
					</a>
				);
			} )}
		</div>
	);
};

export default ResourceList;
